import { Link, useParams } from "react-router-dom";
import { useSeo } from "../lib/seo";
import { MARKETS, IMAGES } from "../lib/constants";
import { PageHero } from "../components/Common";
import { PageFade } from "../components/Motion";
import { Marketplace } from "./Opportunities";

export default function Market() {
  const { slug } = useParams();
  const m = MARKETS[slug] || MARKETS.portland;
  useSeo(`${m.name} Commercial Real Estate Opportunities`, `${m.name}, Oregon commercial real estate investment opportunities sourced by Sido Holdings. ${m.blurb}`);
  return (
    <PageFade>
      <PageHero eyebrow="Oregon Markets" title={`${m.name} Commercial Real Estate`} sub={m.blurb} image={IMAGES.hero}>
        <div className="mt-8 flex flex-wrap gap-2">
          {Object.entries(MARKETS).map(([k, v]) => (
            <Link key={k} to={`/markets/${k}`} className={`px-3 py-1.5 text-xs border ${k === slug ? "bg-gold text-navy border-gold" : "border-paper/30 text-paper/80 hover:border-paper"}`} data-testid={`market-link-${k}`}>{v.name}</Link>
          ))}
        </div>
      </PageHero>
      <Marketplace cities={m.cities} />
    </PageFade>
  );
}
